var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatminimize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 9,
    viewBox: "0 0 18 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.655 1.77887C17.8782 1.58513 18 1.33855 18 1.04795C18 0.466732 17.4724 3.06845e-07 16.8027 3.31636e-07C16.4679 3.44032e-07 16.1635 0.123288 15.9301 0.325832L8.98985 6.49022L2.0699 0.325832C1.83653 0.123288 1.52198 8.9733e-07 1.19729 9.0935e-07C0.527621 9.34142e-07 -4.4042e-07 0.466733 -4.10422e-07 1.04795C-3.95423e-07 1.33855 0.121758 1.58513 0.344983 1.77887L8.05637 8.63014C8.32018 8.87671 8.64487 8.99119 9 9C9.35513 9 9.65953 8.87671 9.93348 8.63014L17.655 1.77887Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatminimize);
export default __webpack_public_path__ + "static/media/chatminimize.710c3557db4deae44bfd69fc4d9d704b.svg";
export { ForwardRef as ReactComponent };